import { Capacitor } from '@capacitor/core';

/**
 * Shell mobile “Relatórios de campo”: nativo (Capacitor) ou browser em dev
 * (Chrome DevTools → defina VITE_MOBILE_FIELD_SHELL=true no .env e reinicie o Vite).
 */
export function useCapacitor() {
  const isNative = Capacitor.isNativePlatform();
  const showMobileFieldShell =
    isNative || import.meta.env.VITE_MOBILE_FIELD_SHELL === 'true';

  return { isNative, showMobileFieldShell };
}
